import type {
  ProviderInstrumentInfo,
  ProviderReward,
  ProviderSubmitConfirmation,
} from './types'

/** Instrument info defines reward vs no-reward type; submit payload only fills amounts when enabled. */
export function buildCompletionReward(
  info: ProviderInstrumentInfo | null | undefined,
  submitConfirmation: ProviderSubmitConfirmation | null,
  stored: ProviderReward | null,
): ProviderReward {
  if (info && !info.reward.enabled) {
    return { enabled: false, amount: null, display: null }
  }
  const amount =
    stored?.amount ?? submitConfirmation?.rewardAmount ?? info?.reward.amount ?? null
  const display =
    stored?.display ?? submitConfirmation?.rewardDisplay ?? info?.reward.display ?? null
  const enabled =
    stored?.enabled ?? submitConfirmation?.rewardEnabled ?? info?.reward.enabled ?? false

  return { enabled, amount, display }
}

export function completionScreenHasReward(reward: ProviderReward): boolean {
  return reward.enabled && Boolean(reward.display?.trim())
}
